module.exports = __webpack_public_path__ + "media/images/flowchart_500-1526a244167e2792e048504b88239f71.svg";